var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNavCommunication2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.466,
    height: 16.984,
    viewBox: "0 0 21.466 16.984",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{fill:#b1b1c9}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun_Communication_1746196",
    transform: "translate(-3.976 -9)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1225",
    cx: 1,
    cy: 1,
    r: 1,
    className: "cls-1",
    transform: "translate(17 15.688)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1226",
    cx: 1,
    cy: 1,
    r: 1,
    className: "cls-1",
    transform: "translate(14 15.688)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1227",
    cx: 1,
    cy: 1,
    r: 1,
    className: "cls-1",
    transform: "translate(20 15.688)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1593",
    d: "M32.4 19.981a7.634 7.634 0 1 0-2.583 2.927l2.749 1.247a.447.447 0 0 0 .621-.505zm-.894.031l.635 2.963-2.172-.988a.447.447 0 0 0-.447.045A6.633 6.633 0 0 1 25.6 23.3a6.7 6.7 0 1 1 5.935-3.575.447.447 0 0 0-.04.286z",
    className: "cls-1",
    transform: "translate(-7.756)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1594",
    d: "M13.7 28.753a5.81 5.81 0 0 1-6.4-.264.447.447 0 0 0-.447-.045l-1.788.818.535-2.484a.447.447 0 0 0-.049-.317 5.81 5.81 0 0 1 4.139-8.425.453.453 0 0 0-.152-.894 6.7 6.7 0 0 0-5.546 6.637 6.776 6.776 0 0 0 .693 2.968l-.693 3.2a.452.452 0 0 0 .63.5l2.368-1.081a6.655 6.655 0 0 0 3.7 1.117 6.735 6.735 0 0 0 3.473-.965.447.447 0 0 0-.465-.764z",
    className: "cls-1",
    transform: "translate(0 -4.499)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavCommunication2);
export default __webpack_public_path__ + "static/media/nav-communication-2.066b94255ff9c0c770d4a100333fd62d.svg";
export { ForwardRef as ReactComponent };